import { Calendar, FileEdit, RefreshCw, XCircle } from "lucide-react";
import { Button } from "randmarcomps";
import { Opportunity } from "../../stores/opportunities/Opportunity";
import DeleteOpportunityWrapper from './DeleteOpportunityWrapper';
import EditOpportunityWrapper from "./EditOpportunityWrapper";
import RenewOpportunityWrapper from './RenewOpportunityWrapper';

interface IProps {
  opportunity: Opportunity;
}

const OpportunityActions = ({ opportunity }: IProps) => {

  return (
    <div className="my-2 mx-1 flex max-w-[250px] flex-col gap-1 p-1">
      <h3 className="ml-2 text-sm font-medium text-primary">
        Edit {opportunity.bidNumber}
      </h3>
      <EditOpportunityWrapper
        bidNumber={opportunity.bidNumber!}
        informationName="Opportunity"
        informationCurrentValue={opportunity.opportunity}
        validateFonction={() => true}
        label={"Opportunity Name"}
      >
        <Button variant="ghost" className="w-full justify-start">
          <FileEdit className="mr-2 h-4 w-4" />
          Name
        </Button>
      </EditOpportunityWrapper>
      <EditOpportunityWrapper
        bidNumber={opportunity.bidNumber!}
        informationName="EndDate"
        informationCurrentValue={opportunity.endDate}
        validateFonction={() => true}
        label={"End Date"}
      >
        <Button variant="ghost" className="w-full justify-start">
          <Calendar className="mr-2 h-4 w-4" />
          End Date
        </Button>
      </EditOpportunityWrapper>

      <hr className="my-1" />

      <h3 className="ml-2 text-sm font-medium text-primary">
        Utilities
      </h3>

      <DeleteOpportunityWrapper
        buttonTitle="Delete Opportunity"
        disabled={opportunity.details && opportunity.details.length > 0}
        text="Delete forever?"
      >
        <Button variant="ghost" className="w-full justify-start">
          <XCircle className="mr-2 h-4 w-4" />
          Delete Opportunity
        </Button>
      </DeleteOpportunityWrapper>

      <RenewOpportunityWrapper disabled={(opportunity.details?.length === 0 && opportunity.resellers?.length === 0)}>
        <Button variant="ghost" className="w-full justify-start">
          <RefreshCw className="mr-2 h-4 w-4" />
          Renew Opportunity
        </Button>
      </RenewOpportunityWrapper>

    </div>
  )
}

export default OpportunityActions;
